import type { ChatItem } from '../../../contracts/harness.types';

/**
 * Each child run's transcript as its Evidence card streams it. The card is the
 * only reader of the child's stream, so it publishes what it folds here, and
 * the step's row follows it without a request of its own.
 */
const transcripts = new Map<string, readonly ChatItem[]>();
const watchers = new Map<string, Set<() => void>>();
const anyWatchers = new Set<() => void>();

const notify = (childAgentRunId: string): void => {
  watchers.get(childAgentRunId)?.forEach((onChange) => onChange());
  anyWatchers.forEach((onChange) => onChange());
};

export const publishLiveChildTranscript = (
  childAgentRunId: string,
  items: readonly ChatItem[] | null
): void => {
  if (items) {
    transcripts.set(childAgentRunId, items);
  } else {
    transcripts.delete(childAgentRunId);
  }
  notify(childAgentRunId);
};

export const getLiveChildTranscript = (
  childAgentRunId: string
): readonly ChatItem[] | undefined => transcripts.get(childAgentRunId);

export const subscribeLiveChildTranscript = (
  childAgentRunId: string,
  onChange: () => void
): (() => void) => {
  const set = watchers.get(childAgentRunId) ?? new Set<() => void>();
  set.add(onChange);
  watchers.set(childAgentRunId, set);
  return () => {
    set.delete(onChange);
    if (set.size === 0) watchers.delete(childAgentRunId);
  };
};

/** Fires when any child transcript is published or cleared. */
export const subscribeAnyLiveChildTranscript = (onChange: () => void): (() => void) => {
  anyWatchers.add(onChange);
  return () => {
    anyWatchers.delete(onChange);
  };
};
